<template>
    <div class="data-aicenter">
	  	<div class="page-header" style="margin-bottom:15px">作用对接</div>
      <el-collapse v-model="activeNames" ref="collapse" style="margin:15px">
        <el-collapse-item :title="item.dockedDicName"  v-for="(item, index) in dockedList" :key="index" :name="index">
          <div style="text-align:left" v-for="(foo, index) in item.actionDockedList" :key="index">
            <pick-tags label=" " labelWidth="15px" :newLine="true" titleName="多发季节" :dynamicTags="foo.dynamicTagMonthList" :tags="foo.ruleMonthList"></pick-tags>
            <pick-tags label="" labelWidth="15px" :newLine="true" titleName="施食规则" :dynamicTags="foo.dynamicTagEfficacyList" :tags="foo.ruleEfficacyList"></pick-tags>
            <el-form label-width="15px">
              <el-form-item></el-form-item>
              <el-form-item style="width:90%;" prop="" label=" " required>
                <el-input type="textarea"  placeholder="请输入内容"
                  v-model="foo.dockedDes"
                  maxlength="300"
                  :rows="5"
                  show-word-limit>
                </el-input>
              </el-form-item>
            </el-form>
            <el-row :span="10" style="text-align:center">
              <el-button type="text" v-if="index+1==item.actionDockedList.length" @click="addRule(item.actionDockedList,item)">添加规则</el-button>
              <el-button type="primary" @click="save(foo)">保存</el-button>
              <el-button type="danger"  @click="cancle(item.actionDockedList,foo,index)">删除</el-button>
            </el-row>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
</template>

<script>
import { fetchDockedInfo,createDocked,delDocked } from '@/api/aicenter'
import { fetchDictListByType } from '@/api/dict'
import PickTags from '@/components/PickTags/index'
export default {
  components: {
    PickTags
  },
  data(){
    return {
      activeNames: [0,1],
      dockedList:[]
    }
  },
  created() {
    this.loadDockedInfo();
  },
  methods: {
    loadDockedInfo() {
      fetchDockedInfo().then(response=>{
        console.log(response.data);
        this.dockedList = response.data;
      })
    },
    addRule(dockedList,item) {
      fetchDictListByType("season").then(response=>{
        fetchDictListByType("efficacy").then(res=>{
          let rule = {
            dockedDicName: item.dockedDicName,
            ruleMonthList: response.data,
            ruleEfficacyList: res.data,
            dynamicTagMonthList:[],
            dynamicTagEfficacyList: [],
            dockedDes: null,
            dockedDicId: item.dockedDicId
          };
          dockedList.push(rule);
        })
      })
    },
    save(foo) {
      console.log(foo);
      if(foo.dynamicTagEfficacyList.length == 0) {
        this.$message.error("请选择施食规则");
        return;
      }
      if(foo.dynamicTagMonthList.length == 0) {
        this.$message.error("请选择多发季节");
        return;
      }
      if(!foo.dockedDes) {
        this.$message.error("请输入说明");
        return;
      }
      createDocked(foo).then(response=>{
        this.$message({
          message: '数据更新成功！',
          type: 'success'
        });
        this.loadDockedInfo();
      })
    },
    cancle(dockedList,foo,index) {
       this.$confirm('是否确认删除当前规则?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          if(foo.id) {
            delDocked(foo.id).then(res=>{
              dockedList.splice(index, 1);
            })
          } else {
            dockedList.splice(index, 1); 
          }
        })
    }
  }
}
</script>

<style scoped>
 .explain {
   width: 85%;
   margin: auto;
   padding-left: 5px;
   padding-right: 20px;
 }
</style>



// WEBPACK FOOTER //
// src/views/aicenter/components/dataopt/actiondock.vue